<lx-price-lists-portal-more-info-list title="Tuition upgrades & add-ons" [moreInfoItems]="tuitionUpgradesAndAddOns"></lx-price-lists-portal-more-info-list>
<lx-price-lists-portal-more-info-title title="Private Lessons"></lx-price-lists-portal-more-info-title>

<p-table [value]="privateLessonsDataSource">
  <ng-template pTemplate="header">
    <tr>
      <th>Number of lessons</th>
      <th *ngFor="let label of privateLessonsTableLabels">{{ label }}</th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-data>
    <tr>
      <td>{{ data.numberOfLessons }}</td>
      <td *ngFor="let price of data.prices">{{ price | lxPrice : { defaultValue: '-' } }}</td>
    </tr>
  </ng-template>
</p-table>

<lx-price-lists-portal-more-info-list title="Accommodation supplement" [moreInfoItems]="accommodationSupplements"></lx-price-lists-portal-more-info-list>
<lx-price-lists-portal-more-info-list title="Peak season supplement" [moreInfoItems]="seasonSupplements"></lx-price-lists-portal-more-info-list>
